import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  CHANGE_INPUT_FILTER_PROVIDERS: "change_input_filter_providers",
  PROVIDERS_LOADED: "providers_loaded",
  SET_FIELD_FORM_PROVIDER: "set_field_form_provider",
  SET_EDIT_FORM_PROVIDER: "set_edit_form_provider",
  EDIT_FORM_PROVIDER: "edit_form_provider",
  RELOAD_INDEX_PROVIDERS: "reload_index_providers",
};

export const INITIAL_STATE = {
  elements: [],
  status: STATUS_NOT_LOADED,
  filter: {
    limit: 20,
    page: 1,
    sortBy: "name",
    sortDir: "asc",
  },
  rows: 0,
  edit_provider: {
    id: null,
    name: "",
    doc_num: "",
    phone: "",
    email: "",
    address: "",
    genre: "",
    city: "",
  },
  for_edit: false,
};

export const providersReducer = (state, action) => {
  const payload = action.payload;
  const {
    CHANGE_INPUT_FILTER_PROVIDERS,
    PROVIDERS_LOADED,
    SET_FIELD_FORM_PROVIDER,
    SET_EDIT_FORM_PROVIDER,
    EDIT_FORM_PROVIDER,
    RELOAD_INDEX_PROVIDERS,
  } = types;

  switch (action.type) {
    case PROVIDERS_LOADED:
      return {
        ...state,
        elements: payload.elements,
        rows: payload.rows,
        status: LOADED,
      };

    case CHANGE_INPUT_FILTER_PROVIDERS:
      return {
        ...state,
        status: STATUS_NOT_LOADED,
        filter: {
          ...state.filter,
          [payload.name]: payload.value,
        },
      };

    case SET_FIELD_FORM_PROVIDER:
      return {
        ...state,
        edit_provider: {
          ...state.edit_provider,
          [payload.name]: payload.value,
        },
      };

    case SET_EDIT_FORM_PROVIDER:
      return {
        ...state,
        for_edit: payload,
      };

    case EDIT_FORM_PROVIDER:
      return {
        ...state,
        edit_provider: payload,
      };

    case RELOAD_INDEX_PROVIDERS:
      return {
        ...state,
        status: STATUS_NOT_LOADED,
      };

    default:
      return state;
  }
};
